import { Fragment, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "@/components/container";
import { KeenIcon } from "@/components";
import {
  Toolbar,
  ToolbarActions,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from "@/partials/toolbar";
import { SystemAnnouncementsListings } from "./SystemAnnouncementsListings";

const SystemAnnouncementsManagement = () => {
  const navigate = useNavigate();

  const handleCreateAnnouncement = useCallback(() => {
    navigate("/system-announcements/create");
  }, [navigate]);

  return (
    <Fragment>
      <Container>
        <Toolbar>
          <ToolbarHeading>
            <ToolbarPageTitle
              id="system-announcements-management-heading"
              text="System announcements"
            />
            <ToolbarDescription>
              Manage and schedule announcements for targeted users across the
              system.
            </ToolbarDescription>
          </ToolbarHeading>
          <ToolbarActions>
            <button
              type="button"
              className="btn btn-sm btn-light flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              onClick={() => navigate("/system-announcements/archived")}
              aria-label="View archived announcements"
            >
              <KeenIcon
                type="filled"
                icon="notepad"
                className="text-gray-500"
              />
              Archived Announcements
            </button>
          </ToolbarActions>
        </Toolbar>
      </Container>

      <Container>
        <SystemAnnouncementsListings
          onCreateAnnouncement={handleCreateAnnouncement}
        />
      </Container>
    </Fragment>
  );
};

export { SystemAnnouncementsManagement };
